<header class="relative h-16 w-full overflow-x-clip text-neutral-800">
    <div class="flex items-center justify-between px-6 py-2">
        <a class="flex cursor-pointer items-center" [routerLink]="['/']">
            <img
                src="assets/logo/hairstyleclub-full-logo.png"
                class="h-8 w-auto cursor-pointer object-contain md:h-12"
                alt="Hair Style Club" />
        </a>

        <div class="block space-x-5">
            <button class="rounded-md px-4 py-1 text-sm" routerLink="/signup">
                Sign Up
            </button>
            <button class="rounded-md px-4 py-1 text-sm" routerLink="/login">
                Sign In
            </button>
        </div>
    </div>

    <span class="absolute top-0 -z-50">
        <!-- ! TODO: Add image -->
    </span>

    <span class="absolute top-0 right-0 -z-50">
        <!-- ! TODO: Add image -->
    </span>
</header>
